import script from "./StepThree.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepThree.vue?vue&type=script&setup=true&lang=ts"

import "./StepThree.vue?vue&type=style&index=0&id=03250cc8&lang=scss"

const __exports__ = script;

export default __exports__